import { TypeChildRecord } from '@/lib/api/accountManager/types';
import { API_URLS } from '@/lib/api/config';
import useSWR from 'swr';

export const useChild = (childUuid: string) => {
  const cleanUuid = childUuid.trim();
  return useSWR<TypeChildRecord>(
    cleanUuid
      ? `${API_URLS.ACCOUNT_MANAGER_PROXY}/children/${childUuid}`
      : null,
  );
};
